import { useRef, useEffect } from 'react';
import { Send, Loader2 } from 'lucide-react';

export const ChatInput = ({ value, onChange, onSubmit, placeholder, disabled, autoFocus }) => {
  const inputRef = useRef(null);

  useEffect(() => {
    if (autoFocus && inputRef.current) inputRef.current.focus();
  }, [autoFocus]);

  return (
    <form onSubmit={onSubmit} className="p-4 border-t border-[#27272A] bg-[#050505] flex-shrink-0 safe-area-bottom">
      <div className="flex gap-2">
        <input
          ref={inputRef}
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          disabled={disabled}
          className="flex-1 px-4 py-3 bg-[#1a1a1a] border border-[#27272A] text-white placeholder-[#52525B] focus:border-[#007AFF] focus:outline-none text-base rounded-lg"
          data-testid="chatbot-input"
        />
        <button
          type="submit"
          disabled={disabled || !value.trim()}
          className="px-4 py-3 bg-[#007AFF] text-white rounded-lg hover:bg-[#3395FF] transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          data-testid="chatbot-send"
          aria-label="Send message"
        >
          {disabled ? <Loader2 className="w-5 h-5 animate-spin" /> : <Send className="w-5 h-5" />}
        </button>
      </div>
    </form>
  );
};
